<div class="map-toggle">
  <span class="map-toggle__text">
    {{ 'common.map' | i18n }}
  </span>
  <div class="map-toggle__toggle">
    <app-toggle-switch
      [isActivated]="(isVisible$ | async) || false"
      (update)="setMapVisible($event)"
    ></app-toggle-switch>
  </div>
</div>
